import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=653a2a64&scoped=true"
import script from "./Attributes.vue?vue&type=script&lang=js"
export * from "./Attributes.vue?vue&type=script&lang=js"
import style0 from "./Attributes.vue?vue&type=style&index=0&id=653a2a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a2a64",
  null
  
)

export default component.exports